import React, { useState } from 'react';
import { ShieldCheck, Lock, Eye, CheckCircle } from 'lucide-react';
export function Footer() {
  const [accessibilityEnabled, setAccessibilityEnabled] = useState(true);
  return <footer className="bg-slate-900 text-white pt-20 pb-10 border-t-8 border-federal-blue" data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-127">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-128">
          <div className="lg:col-span-1" data-id="element-129">
            <div className="flex items-center gap-2 mb-6" data-id="element-130">
              <div className="w-10 h-8 flex items-center justify-center overflow-hidden" data-id="element-131">
                <img src="https://cdn.magicpatterns.com/uploads/qpgdNqUL4qY23U6JmdRkbZ/Codes_and_cogs_(1).png" alt="Codes & Cogs Logo" className="h-full w-auto object-contain brightness-0 invert" data-id="element-132" />
              </div>
              <div className="flex flex-col leading-tight" data-id="element-133">
                <span className="text-white font-black text-lg tracking-tighter uppercase" data-id="element-134">
                  Codes & Cogs
                </span>
                <span className="text-muted-gold text-[8px] font-bold tracking-[0.2em] uppercase" data-id="element-135">
                  Federal Solutions
                </span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-8" data-id="element-136">
              A certified WOSB/EDWOSB entity dedicated to securing the federal
              mission through digital excellence and physical infrastructure.
            </p>
            <div className="flex items-center gap-3 p-3 bg-white/5 border border-white/10 rounded" data-id="element-137">
              <CheckCircle className="w-5 h-5 text-green-500" data-id="element-138" />
              <div data-id="element-139">
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-140">
                  SAM.gov Status
                </p>
                <p className="text-xs font-bold text-white" data-id="element-141">
                  Active Registration
                </p>
              </div>
            </div>
          </div>

          <div data-id="element-142">
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-muted-gold" data-id="element-143">
              Capabilities
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-144">
              <li data-id="element-145">
                <a href="#" className="hover:text-white transition-colors" data-id="element-146">
                  Software Development
                </a>
              </li>
              <li data-id="element-147">
                <a href="#" className="hover:text-white transition-colors" data-id="element-148">
                  Web & Accessibility
                </a>
              </li>
              <li data-id="element-149">
                <a href="#" className="hover:text-white transition-colors" data-id="element-150">
                  Physical Security
                </a>
              </li>
              <li data-id="element-151">
                <a href="#" className="hover:text-white transition-colors" data-id="element-152">
                  IT Supply Chain
                </a>
              </li>
              <li data-id="element-153">
                <a href="#" className="hover:text-white transition-colors" data-id="element-154">
                  Healthcare IT
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-155">
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-muted-gold" data-id="element-156">
              Compliance
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-157">
              <li data-id="element-158">
                <a href="#" className="hover:text-white transition-colors" data-id="element-159">
                  NIST 800-171
                </a>
              </li>
              <li data-id="element-160">
                <a href="#" className="hover:text-white transition-colors" data-id="element-161">
                  NIST 800-53
                </a>
              </li>
              <li data-id="element-162">
                <a href="#" className="hover:text-white transition-colors" data-id="element-163">
                  Section 508
                </a>
              </li>
              <li data-id="element-164">
                <a href="#" className="hover:text-white transition-colors" data-id="element-165">
                  HIPAA Compliance
                </a>
              </li>
              <li data-id="element-166">
                <a href="#" className="hover:text-white transition-colors" data-id="element-167">
                  TAA Compliance
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-168">
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-muted-gold" data-id="element-169">
              Accessibility
            </h4>
            <div className="bg-white/5 p-4 rounded border border-white/10" data-id="element-170">
              <div className="flex items-center justify-between mb-4" data-id="element-171">
                <div className="flex items-center gap-2" data-id="element-172">
                  <Eye className="w-4 h-4 text-slate-300" data-id="element-173" />
                  <span className="text-xs font-bold uppercase tracking-wider" data-id="element-174">
                    Section 508
                  </span>
                </div>
                <button onClick={() => setAccessibilityEnabled(!accessibilityEnabled)} className={`w-10 h-5 rounded-full relative transition-colors ${accessibilityEnabled ? 'bg-muted-gold' : 'bg-slate-700'}`} data-id="element-175">
                  <div className={`absolute top-1 w-3 h-3 bg-white rounded-full transition-all ${accessibilityEnabled ? 'left-6' : 'left-1'}`} data-id="element-176" />
                </button>
              </div>
              <p className="text-[10px] text-slate-400 leading-normal" data-id="element-177">
                This portal is designed to meet or exceed Section 508 standards.
                Toggle high-contrast and screen-reader optimizations.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-178">
          <div className="flex items-center gap-6 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-179">
            <span data-id="element-180">© 2026 Codes & Cogs LLC</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-181">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-182">
              Security Disclaimer
            </a>
          </div>

          <div className="flex items-center gap-4" data-id="element-183">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/5 border border-white/10 rounded text-[10px] font-bold text-slate-300" data-id="element-184">
              <Lock className="w-3 h-3 text-muted-gold" data-id="element-185" />
              SECURE PORTAL
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/5 border border-white/10 rounded text-[10px] font-bold text-slate-300" data-id="element-186">
              <ShieldCheck className="w-3 h-3 text-muted-gold" data-id="element-187" />
              SAM REGISTERED
            </div>
          </div>
        </div>
      </div>
    </footer>;
}